<template>
  <v-list :elevation="elevation">
    <template v-for="(property, i) in properties">
      <v-divider v-if="divider && i > 0" :key="`divider-${i}`" />

      <v-list-item :key="`property-${i}`">
        <v-list-item-content
          v-bind:class="['justify-space-between flex-nowrap', {
            'flex-column': !$vuetify.breakpoint.mdAndUp
          }]"
        >

          <slot name="key" v-bind="{...property }">
            <v-list-item-title v-bind:class="{
              'w-100': !$vuetify.breakpoint.mdAndUp
            }">
              <v-icon v-if="property.icon" left>{{ property.icon }}</v-icon>
              {{ $te(property.key) ? $t(property.key) : property.key }}
            </v-list-item-title>
          </slot>

          <slot name="value" v-bind="{ ...property }">
            <v-list-item-title v-bind:class="['mt-2 mt-md-0 text-md-right', {
              'w-100':!$vuetify.breakpoint.mdAndUp
            }]">
              {{ property.value }}
            </v-list-item-title>
          </slot>

        </v-list-item-content>
      </v-list-item>

    </template>
  </v-list>
</template>

<script>
export default {
  props: {
    elevation: [String, Number],
    properties: {
      type: Array,
      default: () => ([]),
    },
    divider: {
      type: Boolean,
      default: () => true,
    },
  },
};
</script>
